module.exports = __webpack_public_path__ + "img/wzsyt.e0f425a4.png";